import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectFilterByDateModal = createSelector(
  [(store: RootState) => store.massNotification.showFilterByDateModal],
  (status) => status
);
